

export class DataChannelWriter {
    constructor(dc) {
        this.dc = dc;
        this.chunksize = 32<<10;
        this.bufferedAmountHighThreshold = 1<<20;
        this.dc.bufferedAmountLowThreshold = 512<<10;
        this.dc.onbufferedamountlow = () => {
            this.resolve()
        };
        this.ready = new Promise((resolve) => {
            this.resolve = resolve;
            this.resolve();
        });
    }
    async write(buf) {
        for (let offset = 0; offset < buf.length; offset += this.chunksize) {
            let end = offset+this.chunksize;
            if (end > buf.length) {
                end = buf.length;
            }
            await this.ready;
            this.dc.send(buf.subarray(offset, end));
        }
        if (this.dc.bufferedAmount >= this.bufferedAmountHighThreshold) {
            this.ready = new Promise((resolve) => this.resolve = resolve);
        }
    }
}

